var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cate_content"},_vm._l((_vm.cate_data),function(item,index){return _c('div',{key:index,staticClass:"cate_item",style:(`${_vm.font_style}${index == 0 ? _vm.select_style : ''}`)},[_vm._v(_vm._s(item))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }